import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FormsVideosHero } from '../components/forms/FormsVideosHero';
import { VideoGrid } from '../components/forms/VideoGrid';
import { FormsTips } from '../components/forms/FormsTips';
import { CTASection } from '../components/home/CTASection';
export function FormsVideosPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-744">
      <Header data-id="element-745" />

      <main className="pt-20" data-id="element-746">
        <FormsVideosHero data-id="element-747" />
        <VideoGrid data-id="element-748" />
        <FormsTips data-id="element-749" />
        <CTASection data-id="element-750" />
      </main>

      <Footer data-id="element-751" />
    </div>;
}